import { ArrowUpRight } from "lucide-react";
import type { DatabookVarianceFinding } from "@/lib/api/databook";
import { DatabookInspectorPanel, type InspectorPanelProps } from "./DatabookInspectorPanel";

const sectionLabels = /^(Observation|Root cause|Fixability|What to fix|How to fix|Action):\s*(.*)$/;
const categoryLabels = new Set([
  "Client source data issue", "Report formula issue", "Mapping issue", "Root cause unclear",
]);

function explanationSections(text: string) {
  const sections: { label: string | null; text: string; category: boolean }[] = [];
  for (const line of text.split(/\r?\n/)) {
    const field = sectionLabels.exec(line);
    if (field || categoryLabels.has(line.trim())) {
      sections.push({ label: field?.[1] ?? null, text: field?.[2] ?? line.trim(), category: !field });
    } else if (sections.length) {
      sections[sections.length - 1].text += `\n${line}`;
    } else if (line.trim()) {
      sections.push({ label: null, text: line, category: false });
    }
  }
  return sections;
}

export function DatabookVariancePanel({
  finding, ...props
}: InspectorPanelProps & { finding: DatabookVarianceFinding | null }) {
  return <DatabookInspectorPanel {...props} kind="variances">
    {finding && (
          <section className="py-5">
            <h3 className="mb-4 inline-flex rounded-md bg-muted px-2 py-1 font-mono text-xs font-medium text-foreground/80">
              {finding.cell_address}
            </h3>
            <div className="space-y-5">
              {explanationSections(finding.text).map((section, index) => (
                <div key={index} className={section.label === "Action" ? "rounded-lg border border-border bg-muted/40 p-3" : undefined}>
                  {section.label && (
                    <h4 className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                      {section.label === "Action" && <ArrowUpRight aria-hidden="true" size={13} />}
                      {section.label === "Action" ? "Recommended action" : section.label}
                    </h4>
                  )}
                  <p className={section.category
                    ? "text-[13px] font-semibold leading-5 text-amber-700 dark:text-amber-400"
                    : "whitespace-pre-wrap break-words text-[13px] leading-[1.65] text-foreground/90 [overflow-wrap:anywhere]"}>
                    {section.text.trim()}
                  </p>
                </div>
              ))}
            </div>
          </section>
    )}
  </DatabookInspectorPanel>;
}
